import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'invoices/'; // Set your invoice base path

export default {
  // Fetch a single invoice image by month
  fetchInvoiceImage: (month) => {
    return api.get(`${BASE_URL}sample-image`, { responseType: 'blob' }); // Assuming you're fetching a binary image
  },
  // Fetch an invoice PDF by invoice ID
  fetchInvoicePDFById: (invoiceId) => {
    return api.get(`${BASE_URL}${invoiceId}/pdf`, { responseType: 'blob' }); // Fetch invoice PDF by its ID
  },
  fetchInvoiceDatayId: (invoiceId) => {
    return api.get(`${BASE_URL}${invoiceId}`); // Fetch invoice PDF by its ID
  },
  // Get ths s3 blob url directly
  fetchGeneratedInvoicePDFById: (invoiceId) => {
    return api.get(`${BASE_URL}${invoiceId}/approved-pdf`); // Fetch approved invoice PDF by its ID
  },
  // Fetch all invoices for a normal user (userId is optional, defaulting to logged-in user)
  fetchInvoices: () => {
    return api.get(`${BASE_URL}`); // No userId is passed, defaults to logged-in user
  },
  updateInvoicePayoutById: (invoiceId, payout, comment) => {
    return api.put(`${BASE_URL}${invoiceId}/payout`, { payout, comment }); // Sends the payout in the request body
  },
  generateInvoices: (from, to, userIds) => {
    return api.post(`${BASE_URL}generate`, { from, to, userIds });
  },
  approveInvoices: (invoiceIds) => {
    return api.post(`${BASE_URL}approve`, { invoiceIds }); // Send the invoice IDs in the request body
  }
};
